import successImage from '@assets/img/svg/success.svg'
import { withTransaction } from '@elastic/apm-rum-react'
import ButtonToCampaigns from '@src/components/button-to-campaigns/button-to-campaigns.component'
import onConfigChange from '@src/observables/on-config-change.observable'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import MySquid from '@hub/shared/interfaces/my-squid.interface'
import { Subscription } from 'rxjs'
import './success.page.scoped.scss'

const SuccessPage = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const onConfigChangeSubscription = useRef<Subscription | null>(null)
  const [config, setConfig] = useState<MySquid | null>(null)

  const { t } = useTranslation('successPage')

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((config) => {
      setConfig(config)
    })
    return () => {
      onConfigChangeSubscription?.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return (
    <main
      className="success-page box-shadow container display-flex justify-content-center align-items-center"
      style={{ height: width < 991 ? `calc(${height}px - 52px)` : 'auto' }}
    >
      <h1 className="title-page text-center" dangerouslySetInnerHTML={{ __html: t('successTitle') as string }} />
      <figure className="illustration">
        {config && config?._id ? (
          <i className={'fa-regular fa-paper-plane'} style={{ fontSize: '150px', color: 'var(--primary_color)' }}></i>
        ) : (
          <img src={successImage} alt={`${t('titleExpired')}`} />
        )}
      </figure>
      <ButtonToCampaigns className="button" />
    </main>
  )
}

export default withTransaction('Success Page', 'page')(SuccessPage)
